import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakeGetResponder, createFakeDeleteResponder, createFakePostResponder, isWildcard, createFakePutResponder } from '../../test-utils';
import { createQueuesApi } from './';
export var createQueuesTestKit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createQueuesApi(parent, fakeHttp);
    var testKit = {
        whenGetQueue: function (queueId) {
            return createFakeGetResponder(fakeHttp, parent + ("/queues/" + queueId));
        },
        whenGetQueues: function () {
            return createFakeGetResponder(fakeHttp, parent + '/queues');
        },
        whenGetStats: function () {
            return createFakeGetResponder(fakeHttp, parent + '/queues/stats');
        },
        whenDeleteQueue: function (queueId) {
            return createFakeDeleteResponder(fakeHttp, parent + ("/queues/" + queueId));
        },
        whenGetAssignedAgents: function (queueId) {
            return createFakeGetResponder(fakeHttp, parent + ("/queues/" + queueId));
        },
        whenAssignAgentToQueue: function (dto, fail) {
            return createFakePostResponder(fakeHttp, parent + ("/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/agents/" + (isWildcard(dto) ? 'some-agent-id' : dto.agentId)), fail)({});
        },
        whenRemoveAgentFromQueue: function (dto) {
            return createFakeDeleteResponder(fakeHttp, parent + ("/queues/" + (isWildcard(dto) ? 'someid' : dto.queueId) + "/agents/" + (isWildcard(dto) ? 'some-agent-id' : dto.agentId)));
        },
        whenUpdateQueueWaitOfferOptions: function (dto) {
            return createFakePutResponder(fakeHttp, parent + ("/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/queueWaitOfferOptions"))(dto);
        },
        whenUpdateWaitOfferOptions: function (dto) {
            return createFakePutResponder(fakeHttp, parent + ("/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/settings/waitOffers"))(dto.waitOfferSettings);
        },
        whenUpdateOpeningHoursSettings: function (dto) {
            return createFakePutResponder(fakeHttp, parent + ("/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/settings/openingHours"))(isWildcard(dto) ? dto : dto.openingHoursSettings);
        },
        whenUpdateQueueNonAvailableAgentsSettings: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/settings/nonAvailableAgents")(dto);
        },
        whenUpdateCallOptions: function (dto) {
            return createFakePutResponder(fakeHttp, parent + "/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/callOptions")(dto.callOptions);
        },
        whenEnableGlobalCallOptions: function (queueId) {
            return createFakePutResponder(fakeHttp, parent + "/queues/" + queueId + "/globalCallOptions/enable")({});
        },
        whenDisableGlobalCallOptions: function (queueId) {
            return createFakePutResponder(fakeHttp, parent + "/queues/" + queueId + "/globalCallOptions/disable")({});
        },
        whenManualTransferBlock: function (dto) {
            var state = isWildcard(dto) || dto.enabled ? 'enable' : 'disable';
            return createFakePutResponder(fakeHttp, parent + "/queues/" + (isWildcard(dto) ? 'some-id' : dto.queueId) + "/callTransferBlock/" + state)({});
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map